import {
  getPagePreviewSettingQuery,
  getPageProfileQuery,
} from '@redlink/services';

export const freshCache =
  ({ pageName }) =>
  (cache, { data }) => {
    const freshData = data.EditSetting;

    const { PageProfile: oldDataProfile } = cache.readQuery({
      query: getPageProfileQuery,
    });

    cache.writeQuery({
      query: getPageProfileQuery,
      data: {
        PageProfile: {
          ...oldDataProfile,
          settings: { ...oldDataProfile.settings, ...freshData },
        },
      },
    });

    try {
      const { PageSettingPreview: oldData } = cache.readQuery({
        query: getPagePreviewSettingQuery,
        variables: { pageName },
      });

      oldData &&
        cache.writeQuery({
          query: getPagePreviewSettingQuery,
          variables: { pageName },
          data: {
            PageSettingPreview: {
              ...oldData,
              ...freshData,
            },
          },
        });
    } catch (e) {}
  };
